import React, { useEffect, useState } from "react";
import OpenningsTable from "../Components/Table/OpenningsTable";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { roleModulePermissions } from "../utils/roleInstance";
import { MarginRounded } from "@mui/icons-material";

const OpeningsTabDashboard = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
    const [anchorEl2, setAnchorEl2] = useState(null);
  

  // Check Role Permission
  const [openingAction, setOpeningAction] = useState("");

  // const checkOpeningAction = async() => {
  //   const roleData = {
  //     roleModule : 'Questions'
  //   }
  //   let rolePermission = await roleModulePermissions.checkUserRoles(roleData,'add')
  //   // return rolePermission
  //   setOpeningAction(rolePermission)
  // }

  // checkOpeningAction()
  // Check Role Permission
  useEffect(() => {
    const checkOpeningAction = async () => {
      const roleData = {
        roleModule: "Questions",
      };
      const rolePermission = await roleModulePermissions.checkUserRoles(
        roleData,
        "add"
      );
      setOpeningAction(rolePermission);
    };

    checkOpeningAction();
  }, []);

  return (
    <>
      <Box style={{ width: "100%" }}>
        <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "10px",
  }}
>
  <Box
    sx={{
      width: { xs: "100%", sm: "50%", md: "50%" },
      marginRight: { md: "15px", xs: 0 },
    }}
  >
    <TextField
      sx={{ width: "100%" }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="start">
            <IconButton>
              <SearchIcon style={{ color: "#CAC2C2" }} />
            </IconButton>
          </InputAdornment>
        ),
        style: {
          borderRadius: "12px",
          height: "56px",
          padding: 2,
          width: "100%",
        },
      }}
      variant="outlined"
      type="text"
      placeholder="Search Job Role or Recruitment Company"
      onChange={(e) => setSearch(e.target.value)}
    />
  </Box>

  <Box
    sx={{
      display: "flex",
      justifyContent: { xs: "center", md: "flex-end" },
      width: { xs: "100%", sm: "25%", md: "25%" },
    }}
  >
    {openingAction ? (
      <Button
        sx={{
              width: { sm: "100%", xs: "100%", lg: "auto" },
          height: "55px",
          padding: "10px",
          textAlign: "center",
          borderRadius: "8px",
          textTransform: "none",
          fontSize: "15px",
          fontWeight: "500",
          marginBottom: "15px",
          backgroundColor: "secondary.main",
          color: "primary.main",
        }}
        onClick={() => navigate("/selected_question")}
      >
        <AddIcon fontSize="large" /> Create Campaign
      </Button>
    ) : (
      <Button
        sx={{
              width: { sm: "100%", xs: "100%", lg: "auto" },
          height: "55px",
          padding: "10px",
          textAlign: "center",
          borderRadius: "8px",
          textTransform: "none",
          fontSize: "15px",
          fontWeight: "500",
          backgroundColor: "secondary.main",
          color: "primary.main",
        }}
        disabled
      >
        <AddIcon fontSize="large" /> Create Campaign
      </Button>
    )}
  </Box>
</div>

        <Box
          style={{
            zIndex: 1,
            fontSize: "14px",
            // padding: "0 0 12px 4px",
            // margin: "-43px 0 0 0",
          }}
        >
          <p style={{ color: "red", margin: "0 0 15px 0" }}>
            Note:{" "}
            <i>
              The verified opening(s) / request(s) can only be shared to Career
              Portal!
            </i>
          </p>
        </Box>
        <OpenningsTable search={search} />
      </Box>
    </>
  );
};

export default OpeningsTabDashboard;
